import React from "react";
import BodyTemplate from "../BodyTemplate";
import Heading from "../BodyTemplate/Heading";
import {
  PackageBox,
  PackageItem,
  PackageTitle,
  SelectedIcon,
  TopBox,
  BottomBox,
  Subtitle,
  Description,
} from "./packageStyle";

function SelectPackage({
  data = {},
  activePackage,
  selectedPackage,
  width,
  onPackageChange = () => {},
}) {
  return (
    <BodyTemplate p={width > 1079 ? "38px 40px 22px" : "22px 8px 0"}>
      <Heading data={data} />
      {activePackage?.data?.length > 0 && (
        <PackageBox>
          {activePackage?.data?.map((item, index) => (
            <PackageItem
              key={index}
              onClick={() => {
                if (selectedPackage !== index) {
                  onPackageChange(index);
                }
              }}
              isActive={selectedPackage === index}
            >
              <TopBox>
                {selectedPackage === index && (
                  <SelectedIcon icon="icon-plan-check-circle" />
                )}
                <PackageTitle variant="heading5">{item.title}</PackageTitle>
              </TopBox>
              <BottomBox>
                {item.subtitle && (
                  <Subtitle variant="label1">{item.subtitle}</Subtitle>
                )}
                {item.description && (
                  <Description variant="paragraph2">
                    {item.description}
                  </Description>
                )}
              </BottomBox>
            </PackageItem>
          ))}
        </PackageBox>
      )}
    </BodyTemplate>
  );
}

export default SelectPackage;
